var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-modal",
    {
      class: { "footer-none": _vm.btns.length == 0 },
      attrs: { title: _vm.title, width: "80%", destroyOnClose: "" },
      on: { cancel: _vm.close },
      model: {
        value: _vm.modalShow,
        callback: function($$v) {
          _vm.modalShow = $$v
        },
        expression: "modalShow"
      }
    },
    [
      _c(
        "a-form-model",
        {
          ref: "ruleForm",
          staticClass: "common-form-inline",
          attrs: {
            rules: _vm.ruleForm,
            model: _vm.pageData,
            "label-col": { span: 7 },
            "wrapper-col": { span: 13 }
          }
        },
        [
          _c("div", { staticClass: "common-title" }, [_vm._v("合同信息")]),
          _vm._v(" "),
          _vm.pageData.invoiceMainContractFlag
            ? _c(
                "a-row",
                { attrs: { gutter: 24 } },
                [
                  _c(
                    "a-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: "是否为框架合同",
                            prop: "isMainContract"
                          }
                        },
                        [
                          _c("a-select", {
                            staticStyle: { width: "200px" },
                            attrs: {
                              options: _vm.options,
                              placeholder: "请选择"
                            },
                            on: { change: _vm.handleIsMainchange },
                            model: {
                              value: _vm.pageData.isMainContract,
                              callback: function($$v) {
                                _vm.$set(_vm.pageData, "isMainContract", $$v)
                              },
                              expression: "pageData.isMainContract"
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "a-popover",
                            {
                              attrs: { placement: "right" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "content",
                                    fn: function() {
                                      return [
                                        _c("p", [
                                          _vm._v(
                                            "框架合同可以根据实际发生业务调整合同金额"
                                          )
                                        ])
                                      ]
                                    },
                                    proxy: true
                                  }
                                ],
                                null,
                                false,
                                2989656459
                              )
                            },
                            [
                              _vm._v(" "),
                              _c("a-icon", {
                                staticClass: "common-question",
                                attrs: { type: "question-circle" }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "a-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "a-form-model-item",
                        { attrs: { label: "框架合同附件" } },
                        [
                          _c("fileUpload", {
                            attrs: {
                              showList: _vm.invoiceFile,
                              disabled: true,
                              name: "file"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "a-row",
            [
              _c(
                "a-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "a-form-model-item",
                    {
                      attrs: { label: "是否为框架合同", prop: "isMainContract" }
                    },
                    [
                      _c("a-select", {
                        staticStyle: { width: "250px" },
                        attrs: {
                          options: _vm.options,
                          disabled: _vm.readonly,
                          placeholder: "请选择"
                        },
                        on: { change: _vm.handleIsMainchange },
                        model: {
                          value: _vm.pageData.isMainContract,
                          callback: function($$v) {
                            _vm.$set(_vm.pageData, "isMainContract", $$v)
                          },
                          expression: "pageData.isMainContract"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "a-row",
            { attrs: { gutter: 24 } },
            [
              _c(
                "a-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "a-form-model-item",
                    { attrs: { label: "合同编号", prop: "contractNo" } },
                    [
                      _c("a-input", {
                        attrs: {
                          placeholder: "请输入",
                          disabled: _vm.readonly || !_vm.pageData.isMainContract
                        },
                        on: { blur: _vm.getInfo },
                        model: {
                          value: _vm.pageData.contractNo,
                          callback: function($$v) {
                            _vm.$set(_vm.pageData, "contractNo", $$v)
                          },
                          expression: "pageData.contractNo"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "a-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "a-form-model-item",
                    { attrs: { label: "合同名称", prop: "contractName" } },
                    [
                      _c("a-input", {
                        attrs: {
                          placeholder: "请输入",
                          disabled:
                            _vm.readonly ||
                            _vm.contractDisabled ||
                            !_vm.pageData.isMainContract
                        },
                        model: {
                          value: _vm.pageData.contractName,
                          callback: function($$v) {
                            _vm.$set(_vm.pageData, "contractName", $$v)
                          },
                          expression: "pageData.contractName"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "a-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "a-form-model-item",
                    { attrs: { label: "合同金额", prop: "contractAmt" } },
                    [
                      _c("a-input", {
                        attrs: {
                          placeholder: "请输入",
                          disabled:
                            _vm.readonly ||
                            _vm.contractAmountDisabled ||
                            !_vm.pageData.isMainContract,
                          type: "number"
                        },
                        model: {
                          value: _vm.pageData.contractAmt,
                          callback: function($$v) {
                            _vm.$set(_vm.pageData, "contractAmt", _vm._n($$v))
                          },
                          expression: "pageData.contractAmt"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "a-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "a-form-model-item",
                    { attrs: { label: "签订日期", prop: "signDate" } },
                    [
                      _c("a-date-picker", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          showToday: false,
                          placeholder: "请输入",
                          disabled:
                            _vm.readonly ||
                            _vm.contractDisabled ||
                            !_vm.pageData.isMainContract,
                          valueFormat: "YYYY-MM-DD"
                        },
                        model: {
                          value: _vm.pageData.signDate,
                          callback: function($$v) {
                            _vm.$set(_vm.pageData, "signDate", $$v)
                          },
                          expression: "pageData.signDate"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "a-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "a-form-model-item",
                    { attrs: { label: "附件上传", prop: "fileId" } },
                    [
                      _c("fileUpload", {
                        ref: "fileUpload",
                        attrs: {
                          accept:
                            ".png, .PNG, .jpg, .JPG, .jpeg, .JPEG, .bmp, .pdf, .PDF, .zip, .ZIP, .rar, .RAR",
                          showList: [_vm.pageData.file],
                          paramObj: _vm.uploadParam,
                          disabled:
                            _vm.readonly ||
                            _vm.fileReadonly ||
                            _vm.contractDisabled ||
                            !_vm.pageData.isMainContract,
                          name: "file"
                        },
                        on: { uploadOk: _vm.uploadOk, remove: _vm.removeOk }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "common-title" }, [_vm._v("单据列表")]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "table-common common" },
        [
          _c(
            "a-table",
            {
              attrs: {
                size: "middle",
                columns: _vm.columns,
                "row-key": function(record) {
                  return record.id
                },
                "data-source": _vm.tableData,
                pagination: false,
                bordered: "",
                locale: { emptyText: "暂无数据" },
                "row-selection": _vm.tableSelect
              },
              scopedSlots: _vm._u([
                {
                  key: "billTime",
                  fn: function(text) {
                    return [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm._f("dateFormat")(text, "YYYY-mm-dd")) +
                          "\n      "
                      )
                    ]
                  }
                },
                {
                  key: "invoiceAmountWithVat",
                  fn: function(text) {
                    return [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm._f("splitK")(text)) +
                          "\n      "
                      )
                    ]
                  }
                }
              ])
            },
            [
              _vm._v(" "),
              _c("template", { slot: "docTpCd" }, [_vm._v("发票")])
            ],
            2
          ),
          _vm._v(" "),
          _c("div", { staticClass: "table-total-none" }, [
            _vm._v("\n      已选记录：\n      "),
            _c("span", { staticClass: "text-color-blue" }, [
              _vm._v(_vm._s(_vm.selectedRowKeys.length) + " 条")
            ]),
            _vm._v("\n      单据金额：\n      "),
            _c("span", { staticClass: "text-color-orange" }, [
              _vm._v(
                _vm._s(_vm._f("splitK")(_vm.totalPayable(_vm.tableData))) +
                  " 元"
              )
            ]),
            _vm._v("\n      可开立余额：\n      "),
            _c("span", { staticClass: "text-color-orange" }, [
              _vm._v(
                _vm._s(_vm._f("splitK")(_vm.totalCanPayable(_vm.tableData))) +
                  " 元"
              )
            ])
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "template",
        { slot: "footer" },
        [
          _vm.btns.indexOf("close") > -1
            ? _c(
                "a-button",
                {
                  staticClass: "btn-blue-line",
                  on: {
                    click: function($event) {
                      return _vm.close()
                    }
                  }
                },
                [_vm._v("取消")]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.btns.indexOf("save") > -1
            ? _c("button-load", {
                attrs: { type: "primary", lable: "保存" },
                on: { clickHandle: _vm.save }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.btns.indexOf("check") > -1
            ? _c("button-load", {
                attrs: { type: "primary", lable: "查验" },
                on: { clickHandle: _vm.check }
              })
            : _vm._e()
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3c3b30a1", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3c3b30a1","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/bill-manage/payable/contract-info-dialog.vue
// module id = dTQS
// module chunks = 1